import { Component, EventEmitter, HostListener, Output, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ValueService } from '../../services/value-service';

@Component({
  selector: 'app-input-text-cell-renderer',
  templateUrl: "./input-text-cell-renderer.component.html",
  styleUrls: ["./input-text-cell-renderer.component.css"],
  
})
export class InputTextCellRendererComponent implements AfterViewInit {
  params: any;
  displayValue: string = '0.00';
  maxValue: number = 0;
  @ViewChild('inputField') inputField: ElementRef;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor(private valueService: ValueService) {}
  
  agInit(params: any): void {
    this.params = params;
    this.setDisplayValue(params.value);
    this.maxValue = Math.abs(params.data.arap_bal);
  }

  ngAfterViewInit(): void {
    this.updateInputFieldValue();
  }

  setDisplayValue(value: number): void {
    if (isNaN(value)) {
      this.displayValue = '0.00';
    } else {
      const absValue = Math.abs(value).toFixed(2);
      this.displayValue = absValue;
    }
    this.updateInputFieldValue();
  }

  updateInputFieldValue(): void {
    if (this.inputField && this.inputField.nativeElement) {
      this.inputField.nativeElement.value = this.displayValue;
    }
  }

  onInputChange(event: any): void {
    const inputValue = event.target.value.trim(); 
    let numericValue = parseFloat(inputValue);

    if (numericValue > this.maxValue) {
      numericValue = this.maxValue;
    }

    this.params.data.bl_fi_generic_doc_hdr.amount_contra = numericValue;
    this.setDisplayValue(numericValue);
    this.valueService.emitValueChange(numericValue);
  }

  onBlur(): void {
    this.updateInputFieldValue();
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
